export default __webpack_public_path__ + "static/media/suitemaster_7.1d0e4971.jpg";